import { formatDataValue } from 'utils/formatFns';
import { getLatestSalesRegionName } from 'pages/VehicleDetails/sectionMappingVehicleInquiry/distributorSale';

export const salesInfoFields = {
  businessSaleMonth: {
    label: 'Bus. Sale Month',
    getValue: (data) => data?.salesInfo?.retailSales?.[0]?.businessSalesMonthFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  distributorSaleArea: {
    label: 'Distributor Sale Area',
    getValue: (data) =>
      getLatestSalesRegionName({
        distributorDealerSales: data?.salesInfo?.distributorDealerSales,
      }),
    formatValue: (value) => formatDataValue({ value }),
  },
  distributorTransactionNumber: {
    label: 'Distributor Transaction No.',
    getValue: (data) => {
      const distributorSale = data?.salesInfo?.distributorDealerSales?.filter(
        (sale) => sale?.saleType === 'DistributorSale',
      )?.[0];
      return distributorSale?.creditInvoiceNumber || distributorSale?.invoiceNumber;
    },
    formatValue: (value) => formatDataValue({ value }),
  },
  draftNumber: {
    label: 'Draft Number',
    getValue: (data) =>
      data?.salesInfo?.distributorDealerSales?.filter(
        (item) => item.saleType === 'DealerWholesale',
      )?.[0]?.draftNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  region: {
    label: 'Region',
    getValue: (data) =>
      data?.salesInfo?.distributorDealerSales?.filter(
        (sale) => sale?.saleType === 'DealerWholesale',
      )?.[0]?.dealerWholesale?.creditRegionCode ||
      data?.salesInfo?.distributorDealerSales?.filter(
        (sale) => sale?.saleType === 'DealerWholesale',
      )?.[0]?.dealerWholesale?.saleRegionCode,
    formatValue: (value) => formatDataValue({ value }),
  },
  retailDealer: {
    label: 'Retail Dealer',
    getValue: (data) => ({
      dealerCode: data?.salesInfo?.retailSales?.[0]?.retailDealerCode,
      dealerName: data?.salesInfo?.retailSales?.[0]?.retailDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  retailRegion: {
    label: 'Retail Region',
    getValue: (data) => ({
      regionCode: data?.salesInfo?.retailSales?.[0]?.retailRegionCode,
      regionName: data?.salesInfo?.retailSales?.[0]?.retailRegionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  sellToDealer: {
    label: 'Sell To Dealer',
    getValue: (data) => {
      const sale = data?.salesInfo?.distributorDealerSales?.filter(
        (sale) => sale?.saleType === 'DealerWholesale',
      )?.[0];
      return {
        dealerCode: sale?.saleDealerCode,
        dealerName: sale?.saleDealerName,
      };
    },
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  sellToRegion: {
    label: 'Sell To Region',
    getValue: (data) => {
      const sale = data?.salesInfo?.distributorDealerSales?.filter(
        (sale) => sale?.saleType === 'DealerWholesale',
      )?.[0];
      return {
        regionCode: sale?.saleRegionCode,
        regionName: sale?.saleRegionName,
      };
    },
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  transactionNumber: {
    label: 'Transaction No.',
    getValue: (data) => {
      const sale = data?.salesInfo?.distributorDealerSales?.filter(
        (sale) => sale?.saleType === 'DealerWholesale',
      )?.[0];
      return sale?.creditInvoiceNumber || sale?.invoiceNumber;
    },
    formatValue: (value) => formatDataValue({ value }),
  },
  typeSales: {
    label: 'Type Sales',
    getValue: (data) => ({
      saleType: data?.salesInfo?.retailSales?.[0]?.retailSaleType,
      saleTypeDescription: data?.salesInfo?.retailSales?.[0]?.retailSaleTypeDescription,
    }),
    formatValue: ({ saleType, saleTypeDescription }) => {
      const formattedType = formatDataValue({ value: saleType });
      const formattedDescription = formatDataValue({ value: saleTypeDescription });
      return `${formattedType} | ${formattedDescription}`;
    },
  },
};
